import React, { Fragment } from "react";
import styled from "styled-components";
import {
  Modal as RSModal,
  ModalHeader as RSModalHeader,
  Row,
} from "reactstrap";
import { ModalCopyAccess, ModalCopyLogin } from "./shared";
import ModalContent from "./ModalContent";

export const ModalHeader = styled(RSModalHeader)`
  border-bottom: none;
  position: absolute;
  right: 10px;
  z-index: 10;
`;
export const Modal = styled(RSModal)`
  .modal-content {
    border-radius: 0;
    border: none;
    text-align: center;
  }
`;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  }

  toggleBack = (history) => {
    this.toggle();
    history.goBack();
  };

  render() {
    const { history, location } = this.props;
    const viewComponents = {
      notLoggedIn: (props) => (
        <ModalContent
          copy={ModalCopyLogin(history, location)}
          toggle={this.toggle}
          toggleBack={this.toggleBack}
          history={history}
          location={location}
        />
      ),
      accessDenied: (props) => (
        <ModalContent
          copy={ModalCopyAccess(history, location)}
          toggle={this.toggle}
          toggleBack={this.toggleBack}
          history={history}
          location={location}
        />
      ),
    };
    return (
      <Fragment>
        <Modal
          isOpen
          toggle={() => {
            this.toggleBack(history);
          }}
          size="lg"
          centered
        >
          <ModalHeader
            toggle={() => {
              this.toggleBack(history);
            }}
          />
          <Row>{viewComponents[this.props.view](this.props)}</Row>
        </Modal>
      </Fragment>
    );
  }
}
